import { createRoot } from 'react-dom/client';
import App from './App';
import OfflineManager from './offline-manager';

// Clear the existing HTML content
document.body.innerHTML = '<div id="app"></div>';

// Initialize offline manager and register service worker
const offlineManager = OfflineManager.getInstance();
offlineManager.registerServiceWorker().catch(console.error);

// Render your React component instead
const root = createRoot(document.getElementById('app')!);
root.render(<App />);
